import { render } from "./storeSection.vue?vue&type=template&id=1361f230&scoped=true"
import script from "./storeSection.vue?vue&type=script&lang=js"
export * from "./storeSection.vue?vue&type=script&lang=js"

import "./storeSection.vue?vue&type=style&index=0&id=1361f230&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1361f230"]])

export default __exports__